import { render, staticRenderFns } from "./editNewspaper.vue?vue&type=template&id=50ceaf6a&scoped=true&"
import script from "./editNewspaper.vue?vue&type=script&lang=js&"
export * from "./editNewspaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ceaf6a",
  null
  
)

export default component.exports